export enum AuthenticationErrorCode {
  StartFailed = 'BANK_ID_START_FAILED',
}
